import useTranslation from '../hooks/useTranslation';

const LanguageSwitcher = () => {
  const { setLanguage, language } = useTranslation();

  return (
    <select className='languageSwitcher' value={language} onChange={(e) => setLanguage(e.target.value)}>
      <option value="uk">Українська</option>
      <option value="en">English</option>
    </select>
  );
};

export default LanguageSwitcher;
